import {FC, ReactNode} from 'react'

import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type FormItemsWrapperProps = {
  leftItem: ReactNode
  rightItem: ReactNode
}

export const FormItemsWrapper: FC<React.PropsWithChildren<FormItemsWrapperProps>> = ({
  leftItem,
  rightItem,
}) => (
  <>
    <div className="wrapper">
      <div className="item">{leftItem}</div>
      <div className="item">{rightItem}</div>
    </div>

    <style jsx>{`
      .wrapper {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: ${theme.spacing[3]};
      }
      .item {
        flex: 1 0 45%;
      }
      .item:nth-child(even) {
        margin-left: ${theme.spacing[3]};
      }
      @media ${MOBILE_SCREENSIZE} {
        .wrapper {
          display: block;
          margin-top: 0;
        }
        .item {
          margin-top: ${theme.spacing[3]};
        }
        .item:nth-child(even) {
          margin-left: 0;
        }
      }
    `}</style>
  </>
)
